import { useCurrentTeam } from './team';
import { featureAvailable } from 'services/features-service';

export const useFeatureAvailable = (featureType, planDefault) => {
    const currentTeam = useCurrentTeam();

    return featureAvailable(featureType, planDefault, currentTeam);
};
